/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { ApiResult, DeviceFirmwareResponse } from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    DeviceFirmwareResponseFromJSON,
    DeviceFirmwareResponseToJSON,
} from "../models/index";

export interface FirmwareStatusSetRequest {
    containerName: string;
    filename: string;
    status: FirmwareStatusSetStatusEnum;
    notes?: string;
}

export interface ListFirmwareForDeviceRequest {
    deviceIdentity: string;
    includeDisabled?: boolean;
}

export interface ListFirmwareForModelRequest {
    deviceType: string;
    deviceModel: string;
    includeDisabled?: boolean;
}

/**
 *
 */
export class DeviceFirmwareHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Enable/disable firmware. Admin only.
     */
    async firmwareStatusSetRaw(
        requestParameters: FirmwareStatusSetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["containerName"] == null) {
            throw new runtime.RequiredError(
                "containerName",
                'Required parameter "containerName" was null or undefined when calling firmwareStatusSet().',
            );
        }

        if (requestParameters["filename"] == null) {
            throw new runtime.RequiredError(
                "filename",
                'Required parameter "filename" was null or undefined when calling firmwareStatusSet().',
            );
        }

        if (requestParameters["status"] == null) {
            throw new runtime.RequiredError(
                "status",
                'Required parameter "status" was null or undefined when calling firmwareStatusSet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["containerName"] != null) {
            queryParameters["container_name"] =
                requestParameters["containerName"];
        }

        if (requestParameters["filename"] != null) {
            queryParameters["filename"] = requestParameters["filename"];
        }

        if (requestParameters["status"] != null) {
            queryParameters["status"] = requestParameters["status"];
        }

        if (requestParameters["notes"] != null) {
            queryParameters["notes"] = requestParameters["notes"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-firmware/status`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Enable/disable firmware. Admin only.
     */
    async firmwareStatusSet(
        requestParameters: FirmwareStatusSetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.firmwareStatusSetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * List all firmware compatible with the specified device taking into account hardware revision and current firmware version
     */
    async listFirmwareForDeviceRaw(
        requestParameters: ListFirmwareForDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceFirmwareResponse>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling listFirmwareForDevice().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["includeDisabled"] != null) {
            queryParameters["include_disabled"] =
                requestParameters["includeDisabled"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/firmware`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceFirmwareResponseFromJSON),
        );
    }

    /**
     * List all firmware compatible with the specified device taking into account hardware revision and current firmware version
     */
    async listFirmwareForDevice(
        requestParameters: ListFirmwareForDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceFirmwareResponse>> {
        const response = await this.listFirmwareForDeviceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * List all firmware compatible with specified device type and model.
     */
    async listFirmwareForModelRaw(
        requestParameters: ListFirmwareForModelRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceFirmwareResponse>>> {
        if (requestParameters["deviceType"] == null) {
            throw new runtime.RequiredError(
                "deviceType",
                'Required parameter "deviceType" was null or undefined when calling listFirmwareForModel().',
            );
        }

        if (requestParameters["deviceModel"] == null) {
            throw new runtime.RequiredError(
                "deviceModel",
                'Required parameter "deviceModel" was null or undefined when calling listFirmwareForModel().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["includeDisabled"] != null) {
            queryParameters["include_disabled"] =
                requestParameters["includeDisabled"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-firmware/{deviceType}/{deviceModel}`
                    .replace(
                        `{${"deviceType"}}`,
                        encodeURIComponent(
                            String(requestParameters["deviceType"]),
                        ),
                    )
                    .replace(
                        `{${"deviceModel"}}`,
                        encodeURIComponent(
                            String(requestParameters["deviceModel"]),
                        ),
                    ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceFirmwareResponseFromJSON),
        );
    }

    /**
     * List all firmware compatible with specified device type and model.
     */
    async listFirmwareForModel(
        requestParameters: ListFirmwareForModelRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceFirmwareResponse>> {
        const response = await this.listFirmwareForModelRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}

/**
 * @export
 */
export const FirmwareStatusSetStatusEnum = {
    Enabled: "enabled",
    Disabled: "disabled",
} as const;
export type FirmwareStatusSetStatusEnum =
    (typeof FirmwareStatusSetStatusEnum)[keyof typeof FirmwareStatusSetStatusEnum];
